import {Component, Inject} from '@angular/core';
import {defaultForeignCurrencySettings, ForeignCurrencySettings, Settings} from "../../../../../core/models";
import {FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-foreign-currency-settings-dialog',
  templateUrl: './foreign-currency-settings-dialog.component.html',
  styleUrl: './foreign-currency-settings-dialog.component.scss',
  standalone: false
})
export class ForeignCurrencySettingsDialogComponent {

  settings: ForeignCurrencySettings;
  form: FormGroup = new FormGroup({
    calc_field: new FormControl('exchange_rate'),
  });

  constructor(public dialogRef: MatDialogRef<ForeignCurrencySettingsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: Settings) { }


  ngOnInit(): void {
    this.settings = {
      ...defaultForeignCurrencySettings,
      ...this.data['foreign-currency']
    };
    this.form.patchValue(this.settings);
  }

  doSave(): void {
    this.dialogRef.close(this.form);
  }
}
